import styled from 'styled-components';

import { ReactComponent as PlusIcon } from 'assets/icons/plusIcon.svg';
import Button from 'components/common/Button';

export const StyledPlusIcon = styled(PlusIcon)`
  height: 2.2rem;
  width: 2.2rem;
  path {
    stroke: ${({ theme }) => theme.new.colors.brand};
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  margin-top: 1rem;
`;

export const StyledButton = styled(Button)`
  align-items: center;
  display: flex;
  font-size: 1.5rem;
  gap: 0.3rem;
  height: 3.8rem;
  justify-content: center;
  line-height: 2.043rem;
  margin-top: 0.8rem;
`;
